// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/login_bird.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_container {
        display: flex;
        align-items: center;
        width: 100%;
        overflow: hidden;
}

.Login_imageBox {
        width: 50%;
        height: 100%;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-size: 100% auto;
}

.Login_contentBox {
        margin: auto;

        height: 100%;
        width: 50%;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 75px;

        background-color: #f3f4f6;
}

.Login_imageRow {
        display: flex;
        flex-direction: column;
        align-items: right;
        width: -moz-fit-content;
        width: fit-content;
}

.Login_appLogo {
        width: 350px;
}

.Login_brandLogo_container {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
}

.Login_brandLogo_label {
        font-family: "Montserrat-Italic";
}

.Login_brandLogo {
        height: 15px;
        margin-left: 5px;
}

.Login_buttonsRow {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

.Login_buttonsRow_label {
        font-family: "Montserrat-Italic";
        font-size: 16px;
}

.Login_buttonsRow_buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
}

.Login_error {
        color: red;
        font-family: "Montserrat";
        font-size: 14px;
        margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Login/Login.css"],"names":[],"mappings":"AAAA;QACQ,aAAa;QACb,mBAAmB;QACnB,WAAW;QACX,gBAAgB;AACxB;;AAEA;QACQ,UAAU;QACV,YAAY;QACZ,yDAAyD;QACzD,0BAA0B;AAClC;;AAEA;QACQ,YAAY;;QAEZ,YAAY;QACZ,UAAU;;QAEV,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;;QAET,yBAAyB;AACjC;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,uBAAkB;QAAlB,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;AACjC;;AAEA;QACQ,gCAAgC;AACxC;;AAEA;QACQ,YAAY;QACZ,gBAAgB;AACxB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,uBAAuB;AAC/B;;AAEA;QACQ,gCAAgC;QAChC,eAAe;AACvB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,8BAA8B;AACtC;;AAEA;QACQ,UAAU;QACV,yBAAyB;QACzB,eAAe;QACf,gBAAgB;AACxB","sourcesContent":[".Login_container {\n        display: flex;\n        align-items: center;\n        width: 100%;\n        overflow: hidden;\n}\n\n.Login_imageBox {\n        width: 50%;\n        height: 100%;\n        background-image: url(../../assets/images/login_bird.png);\n        background-size: 100% auto;\n}\n\n.Login_contentBox {\n        margin: auto;\n\n        height: 100%;\n        width: 50%;\n\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 75px;\n\n        background-color: #f3f4f6;\n}\n\n.Login_imageRow {\n        display: flex;\n        flex-direction: column;\n        align-items: right;\n        width: fit-content;\n}\n\n.Login_appLogo {\n        width: 350px;\n}\n\n.Login_brandLogo_container {\n        margin-top: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n}\n\n.Login_brandLogo_label {\n        font-family: \"Montserrat-Italic\";\n}\n\n.Login_brandLogo {\n        height: 15px;\n        margin-left: 5px;\n}\n\n.Login_buttonsRow {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n}\n\n.Login_buttonsRow_label {\n        font-family: \"Montserrat-Italic\";\n        font-size: 16px;\n}\n\n.Login_buttonsRow_buttons {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n}\n\n.Login_error {\n        color: red;\n        font-family: \"Montserrat\";\n        font-size: 14px;\n        margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
